import React, {Component} from 'react';

import LogoPic from "../../assets/images/logo.png";
import API from '../../services/API';
import {Link} from "react-router-dom";
import Toast from '../Common/Toast';
import { toast } from 'react-toastify';
import { faSms } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
class Verify extends Component {
    state = {
        otp : window.localStorage.getItem("otp") ? window.localStorage.getItem("otp") : "",
        mobile : window.localStorage.getItem("mobile"),
        buttonStatus: window.localStorage.getItem("otp") ? "" : "disabled",
        buttonText : window.localStorage.getItem("new_user") === 1 ?   "ثبت نام در سامانه" : "ورود به سامانه",
        loading: "d-none",
        message: "",
        second: 90,
        push_id : window.localStorage.getItem("npid") ? window.localStorage.getItem("npid") : null,
    }
    onInputChange = (event) => {
        const otp = event.target.value;
        if (otp.length >= 6) {
            return false;
        }
        if (otp.length === 5) {
            this.setState({buttonStatus: ""})
        } else {
            this.setState({buttonStatus: "disabled"})
        }


        this.setState({otp});
    }
    onButtonClick =  () => {
        const buttonText  = "";
        const  loading = "d-inline-block";
        const buttonStatus = "disabled";
        this.setState({buttonText,loading,buttonStatus });
        const mobile = this.state.mobile;
        const otp = this.state.otp;
        const push_id = this.state.push_id;
        API.loginWithOTP(mobile , otp,push_id)
            .then((response) => {
                toast.success(response.user_message);
                const new_user =  window.localStorage.getItem("new_user");
                window.localStorage.removeItem("mobile");
                window.localStorage.removeItem("otp");
                window.localStorage.removeItem("new_user");
                window.localStorage.setItem("token",response.results.token);
                setTimeout (() => {
                    new_user > 0 ?  this.props.history.push("/register") :  this.props.history.push("/home/1");

                },1500)
            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
                const buttonText  = "دریافت کد تایید";
                const  loading = "d-none";
                const buttonStatus = "";
                this.setState({buttonText,loading,buttonStatus });
            });
    }
    onResendClick =  () => {

        const mobile = this.state.mobile;
        const request = {
            'mobile' : mobile,
            'i_am_expert' : 1
        }
        API.sendOTP(request)
            .then((response) => {
                toast.success(response.user_message);
                if (typeof response.results.otp !== 'undefined') {
                    window.localStorage.setItem("otp",response.results.otp);
                    const otp = response.results.otp;
                    this.setState({otp})
                }
            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
    }
    render() {
        return (
            <React.Fragment>
                <Toast  />
                <section className="container-fluid bg-white ">
                    <div className="row">
                        <div className="col-12 pt-2 ">
                            <div className=" vh100">
                                <div className="col-12 pt-2">
                                    <img src={LogoPic} alt="Gohar Zamin" className="rounded-3 mx-auto d-block mt-5  " />
                                </div>
                                <h3 className="col-12 text-center mt-5 mb-3 header-text">
                                    ورود به سامانه گوهر زمین
                                </h3>
                                <hr className="w-50 m-auto my-3 text-secondary"/>
                                <div className="mt-5 px-5">
                                    <input type="tel" autoFocus value={this.state.otp} onChange={this.onInputChange}
                                           className="form-control form-control-lg text-center rounded-more"
                                           aria-describedby="passwordHelpBlock" placeholder="کد تایید"/>
                                    <small id="passwordHelpBlock"
                                           className="form-text text-muted super-small d-block mt-4 mb-1  text-center">
                                        کد تایید ارسال شده به شماره
                                        &nbsp;
                                        <strong>
                                            {this.state.mobile}
                                        </strong>
                                        &nbsp;
                                       را وارد کنید
                                        &nbsp;
                                        <Link to="/login" className="text-decoration-none" >

                                                تغییر شمار موبایل

                                        </Link>
                                    </small>
                                </div>
                                <div className="fixed-bottom  max-w-lg">
                                    <button onClick={this.onButtonClick} disabled={this.state.buttonStatus} type="submit"
                                            className="btn btn-primary w-100 py-2">
                                        {this.state.buttonText}
                                        <span  className={"spinner-grow spinner-grow-sm " + this.state.loading} role="status"
                                               aria-hidden="true"></span>
                                    </button>
                                </div>
                                { this.state.second ?                             <div className="rtl mt-4 text-center small text-secondary">
                                    {this.state.second}
                                    &nbsp;
                                    ثانیه
                                    تا درخواست مجدد کد تایید
                                </div> : <span></span>}
                                {!this.state.second &&
                                <div className="rtl mt-4 text-center text-success pointer " onClick={this.onResendClick}>
                                    <FontAwesomeIcon icon={faSms} />

                                    &nbsp;
                                    ارسال مجدد کد تایید
                                </div> }

                            </div>
                        </div>


                    </div>
                </section>
            </React.Fragment>
        );
    }
    componentDidMount =()  =>{
        let countDown = setInterval(() =>{

            let second = this.state.second - 1;
            this.setState({second});
            if(!second) {
                clearInterval(countDown)
            }
        }, 1000);
    }


}

export default Verify;